import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogCustomAnnotationDropdownContentItemIcon from './VeltCommentDialogCustomAnnotationDropdownContentItemIcon/VeltCommentDialogCustomAnnotationDropdownContentItemIcon';
import VeltCommentDialogCustomAnnotationDropdownContentItemLabel from './VeltCommentDialogCustomAnnotationDropdownContentItemLabel/VeltCommentDialogCustomAnnotationDropdownContentItemLabel';
import { transformWireframeProps } from '../../../../../utils/propUtils';
;
var VeltCommentDialogCustomAnnotationDropdownContentItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogCustomAnnotationDropdownContentItem.Label = VeltCommentDialogCustomAnnotationDropdownContentItemLabel;
VeltCommentDialogCustomAnnotationDropdownContentItem.Icon = VeltCommentDialogCustomAnnotationDropdownContentItemIcon;
export default VeltCommentDialogCustomAnnotationDropdownContentItem;
